<mat-dialog-content>
    <div *ngIf="isLoading" class="overlay"></div>
    <div *ngIf="isLoading" class="loader"></div>
    <mat-tab-group class="mat-tab-group">
        <mat-tab label="General Data">
            <mat-card>
                <mat-card-content>
                    <h1 class="menu-sub-item-header mat-icon-container">{{isUpdate ? 'Maintain' : 'Create'}} Product</h1>
                    <p>
                    <form [formGroup]="productForm">

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Title: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="title" matInput formControlName="title" required />
                                </div>
                            </div>
                        </div>
                        
                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Description: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div>
                                    <mat-form-field appearance="outline">
                                        <textarea  name="description" matInput cols="40"  formControlName="description" rows="3"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Choose Supplier: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <kendo-combobox
                                    [data]="listItemsSupplier"
                                    [allowCustom]="allowCustom"
                                    placeholder="Choose Item"
                                    [value] = "selectedValuesSupplier"
                                    (valueChange)="onSizeChangeSupplier($event)"
                                ></kendo-combobox>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Store: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="store" matInput formControlName="store" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Cost Price: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="costPrice" matInput formControlName="costPrice" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Items per Unit: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="itemsPerUnit" matInput formControlName="itemsPerUnit" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock Count: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockCount" matInput formControlName="stockCount" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock Count Date: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <kendo-datetimepicker name="stockCountDate" formControlName="stockCountDate"
                                        [format]="format"
                                        [(value)]="valueStockDate"
                                        [adaptiveMode]="adaptiveMode"
                                        title="Select Date & Time"
                                        subtitle="MM/dd/yyyy HH:mm"
                                    >
                                    </kendo-datetimepicker>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Stock Count By: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="stockCountBy" matInput formControlName="stockCountBy" />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock Alert: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockAlert" matInput formControlName="stockAlert" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock Warning: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockWarning" matInput formControlName="stockWarning" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label class="required">Stock ReOrder Amount Suggested: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockReOrderAmountSuggested" matInput formControlName="stockReOrderAmountSuggested" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Stock ReOrder Amount Last Bought: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input type="number" name="stockReOrderAmountLastBought" matInput formControlName="stockReOrderAmountLastBought" />
                                </div>
                            </div>
                        </div>
                        
                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Stock ReOrder Amount Last Bought Date: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <kendo-datetimepicker name="stockReOrderAmountLastBoughtDate" formControlName="stockReOrderAmountLastBoughtDate"
                                        [format]="format"
                                        [(value)]="valueStockReOrderDate"
                                        [adaptiveMode]="adaptiveMode"
                                        title="Select Date & Time"
                                        subtitle="MM/dd/yyyy HH:mm"
                                    >
                                    </kendo-datetimepicker>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>StockReOrdered (Make Boolean/Checkbox): </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input id="stockReOrdered" type="checkbox"  name="inStock" [checked]="isStockReOrderedChecked" (change)="onStockCheckboxChange($event)" [(ngModel)]="isStockReOrderedChecked">
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Stock ReOrdered By: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="stockReOrderedBy" matInput formControlName="stockReOrderedBy" />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    &nbsp;
                                </div>
                            </div>
                          </div>

                    </form>
                </mat-card-content>
                <mat-card-actions class="mat-form-button-container">
                    <div class="flex flex-align-items-center">
                        <div class="mr-auto">
                        </div>
                        <button style="float: none;" type="button" mat-raised-button (click)="dialogRef.close()"
                            color="warn">Cancel</button>
                        <button style="float: none;" type="button" mat-raised-button (click)="isUpdate ? updateProduct() : addProduct()" color="warn"
                            [disabled]="!productForm.valid">{{isUpdate ? 'Save' : 'Add'}}</button>
                    </div>
                    <br/>
                </mat-card-actions>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</mat-dialog-content>
